export default __webpack_public_path__ + "static/media/brand9.cef5e4ca.svg";